<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="pharmacySegment" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@pharmacySegment">
    Pharmacy Segment
    <span class="text-danger-text">*</span>
  </label>
  <select
    id="pharmacySegment"
    formControlName="pharmacySegment"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacySegment')?.invalid && pharmacyForm().get('pharmacySegment')?.touched
    ">
    <option value="" i18n="@@selectPharmacySegment">Select Pharmacy Segment</option>
    @for (segment of segments(); track segment.id) {
      <option [value]="segment.id">{{ isArabic() ? segment.titleAr : segment.titleEn }}</option>
    }
  </select>

  @if (pharmacyForm().get("pharmacySegment")?.invalid && pharmacyForm().get("pharmacySegment")?.touched) {
    <span class="text-danger-text text-[12px]">
      @if (pharmacyForm().get("pharmacySegment")?.errors?.["required"]) {
        <span i18n="@@pharmacySegmentRequired">Pharmacy Segment is required</span>
      }
    </span>
  }
</div>
